import { flow, Instance, SnapshotIn, SnapshotOut, types } from 'mobx-state-tree';
import { PreviewModel, ViewBoxModel } from './preview';
import { logSDKError } from '../../_shared/logger';

export type TPreviewSvgModel = typeof PreviewSvgModel;
export type PreviewSvgModelInstance = Instance<TPreviewSvgModel>;
export interface IPreviewSvgModelIn extends SnapshotIn<TPreviewSvgModel> {}
export interface IPreviewSvgModelOut extends SnapshotOut<TPreviewSvgModel> {}
export interface IPreviewSvgModel extends PreviewSvgModelInstance {}

export const PreviewSvgModel = PreviewModel.named('PreviewSvgModel')
  .props({
    type: types.string,
    frameUrl: types.maybe(types.string),
    backgroundUrl: types.maybe(types.string),

    viewBox: ViewBoxModel,
    innerViewBox: ViewBoxModel,
  })
  .actions(self => ({
    /**
     * Used to swap image between slots
     */
    swapImages: flow(function* swapImages(userImageAreaIdFrom: string, userImageAreaIdTo: string) {
      try {
        yield self.sdkProject?.swapUserImageAreaContent(self.productId, userImageAreaIdFrom, userImageAreaIdTo);
      } catch (error) {
        logSDKError(error, { productId: self.productId, userImageAreaIdFrom, userImageAreaIdTo });
      }
    }),
  }));
